<template>
<div id="publication-list">
    <h1>Publication</h1>
    <div class="publication-container">
        <el-timeline>
            <div v-for="(i, index) in published" :key="i.id">
                <PublicationItem :item="i" :index="index" :itemStatus="itemStatus" :switchStatus="switchStatus"/>
            </div>
        </el-timeline>
    </div>
</div>
</template>

<script>
import PublicationItem from './PublicationItem.vue'

export default {
    name: 'PublicationList',
    components: { PublicationItem },
    data() {
        return {
            itemStatus: [],
            published: [
                {
                    id: "lam2025codecrash",
                    name: 'CodeCrash: Exposing LLM Fragility to Misleading Natural Language in Code Reasoning',
                    authors: ["Man Ho Lam",  "Chaozheng Wang", "Jen-tse Huang", "Michael R. Lyu"],
                    figname: "lam2025codecrash.png",
                    conference: "<a href='https://neurips.cc/Conferences/2025'>NeurIPS, 2025</a>",
                    paper: "arXiv",
                    websiteLink: 'https://cuhk-arise.github.io/CodeCrash/',
                    paperLink: 'https://arxiv.org/abs/2504.14119',
                    codeLink: 'https://github.com/CUHK-ARISE/CodeCrash',
                },
                {
                    id: "huang2024far",
                    name: 'How Far Are We on the Decision-Making of LLMs? Evaluating LLM\' Gaming Ability in Multi-Agent Environments',
                    authors: ["Jen-tse Huang", "Eric John Li", "Man Ho Lam", "Tian Liang", "Wenxuan Wang", "Youliang Yuan", "Wenxiang Jiao", "Xing Wang", "Zhaopeng Tu", "Michael R. Lyu"],
                    figname: "huang2024far.png",
                    conference: "ICLR, 2025",
                    conference: "<a href='https://iclr.cc/Conferences/2025'>ICLR, 2025</a>",
                    paper: "arXiv",
                    paperLink: 'https://arxiv.org/abs/2403.11807',
                    codeLink: 'https://github.com/CUHK-ARISE/GAMABench',
                },
                {
                    id: "huang2023emotionally",
                    name: "Apathetic or Empathetic? Evaluating LLMs' Emotional Alignment with Humans",
                    authors: ["Jen-tse Huang", "Man Ho Lam", "Eric John Li", "Shujie Ren", "Wenxuan Wang", "Wenxiang Jiao", "Zhaopeng Tu", "Michael R. Lyu"],
                    figname: "huang2023emotionally.png",
                    conference: "<a href='https://neurips.cc/Conferences/2024'>NeurIPS, 2024</a>",
                    paper: "arXiv",
                    paperLink: 'https://arxiv.org/abs/2308.03656',
                    codeLink: 'https://github.com/CUHK-ARISE/EmotionBench',
                },
                {
                    id: "huang2023reliability",
                    name: 'On the Reliability of Psychological Scales on Large Language Models',
                    authors: ["Jen-tse Huang", "Wenxiang Jiao", "Man Ho Lam", "Eric John Li", "Wenxuan Wang", "Michael R. Lyu"],
                    figname: "huang2024reliability.png",
                    conference: "<a href='https://2024.emnlp.org'>EMNLP Main, 2024</a>",
                    paper: "arXiv",
                    paperLink: 'https://arxiv.org/abs/2305.19926',
                    codeLink: 'https://github.com/CUHK-ARISE/LLMPersonality',
                },
                {
                    id: "huang2024humanity",
                    name: 'On the Humanity of Conversational AI: Evaluating the Psychological Portrayal of LLMs',
                    authors: ["Jen-tse Huang", "Wenxuan Wang", "Eric John Li", "Man Ho Lam", "Shujie Ren", "Youliang Yuan", "Wenxiang Jiao", "Zhaopeng Tu", "Michael R. Lyu"],
                    figname: "huang2024humanity.png",
                    conference: "<a href='https://iclr.cc/Conferences/2024'>ICLR, 2024</a> <font color='red'>[Oral 86/7404 1.16%]</font>",
                    paper: "arXiv",
                    paperLink: 'https://arxiv.org/abs/2310.01386',
                    codeLink: 'https://github.com/CUHK-ARISE/PsychoBench',
                },
            ],
        }
    },
    methods: {
        switchStatus(index){
            let status = this.itemStatus[index] === '' ? 'collapsed' : ''
            this.itemStatus.forEach((e, i) => {
                if(index === i){
                    this.itemStatus.splice(i, 1, status)
                }else{
                    this.itemStatus.splice(i, 1, 'collapsed')
                }
            })
        }
    },
    mounted() {
        for(let i = 0; i < this.items.length; i++){
            this.itemStatus.push('collapsed')
        }
    },
}
</script>

<style scoped>
#publication-list{
    width: 1000px;
    min-width: 1000px;
    margin: 50px auto;
}
h1{
    font-size: 30px;
    line-height: 1.0;
    text-align: left;
    color: #111111;
    font-family: "Comic Sans MS", "Comic Sans", "cursive";
    font-weight: bolder;
}
.publication-container, .preprint-container{
    width: 1000px;
    margin: auto;
}
a {
    text-decoration: none;
    color: #3670C9;
    cursor: pointer;
}

a:hover {
    color: #FF5733;
}

</style>